var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-acts"},[_c('avl-player-action',{attrs:{"is-shown":!!_vm.getMyself && _vm.amAllowedToExecute && !!_vm.getExecuted,"backdrop-disabled":true,"title":'Choose a player to execute!',"button-success":{
      callback: function () { return this$1.$store.dispatch('executePlayer', {
          gameId: this$1.$route.params.id,
          submit: true,
        }); },
      label: 'Execute',
    }}}),_c('avl-player-action',{attrs:{"is-shown":!!_vm.getMyself && _vm.amAllowedToAct,"backdrop-disabled":true,"title":'Choose your action.',"button-success":{
      callback: function () { return this$1.$store.dispatch('questAction', {
          gameId: this$1.$route.params.id,
          action: 'SUCCESS',
        }); },
      label: 'Success',
    },"button-danger":{
      callback: function () { return this$1.$store.dispatch('questAction', {
          gameId: this$1.$route.params.id,
          action: 'FAIL',
        }); },
      disabled:
        _vm.getStartingOptions.failFromServantsDisallowedMode && _vm.getMyself.role.team === 'SERVANTS',
      label: 'Fail',
    }}}),_c('avl-player-action',{attrs:{"is-shown":!!_vm.getMyself && _vm.playersAreChooseable,"backdrop-disabled":true,"title":("Submit your team: " + (_vm.getProposedTeam.length) + " / " + _vm.getActiveQuestPlayersNeeded),"button-success":{
      callback: function () { return this$1.$store.dispatch('proposeTeam', {
          gameId: this$1.$route.params.id,
          submit: true,
        }); },
      disabled: !_vm.getCorrectAmountOfPlayersIsChosen,
      label: 'Submit',
    },"button-danger":{
      callback: function () { return this$1.$store.dispatch('clearProposedTeam', this$1.$route.params.id); },
      label: 'Clear',
    }}}),_c('avl-player-action',{attrs:{"is-shown":!!_vm.getMyself && _vm.amAllowedToVote,"backdrop-disabled":true,"title":'What do you say?',"button-success":{
      callback: function () { return this$1.$store.dispatch('teamVote', {
          gameId: this$1.$route.params.id,
          vote: 'APPROVE',
        }); },
      label: 'Approve',
    },"button-danger":{
      callback: function () { return this$1.$store.dispatch('teamVote', {
          gameId: this$1.$route.params.id,
          vote: 'REJECT',
        }); },
      label: 'Reject',
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }